"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZE_STYLES = exports.KIND_STYLES = exports.COLOR_STYLES = exports.CLASSNAME_BASE = void 0;
var _js = require("@quintoandar/cozy-theme/tokens/js");
var icon = _js.alias.color.icon;
var CLASSNAME_BASE = exports.CLASSNAME_BASE = 'Cozy__Icon';
var KIND_STYLES = exports.KIND_STYLES = {
  inherit: 'inherit',
  "default": icon["default"],
  lighter: icon.lighter,
  disabled: icon.disabled,
  onDisabled: icon.onDisabled,
  inverseDefault: icon.inverse["default"],
  inverseLighter: icon.inverse.lighter,
  inverseDisabled: icon.inverse.disabled,
  critical: icon.critical["default"],
  warning: icon.warning,
  positive: icon.positive,
  onSelectedDefault: icon.onSelected["default"],
  onSelectedHovered: icon.onSelected.hovered,
  interactionDefault: icon.interaction["default"],
  interactionHovered: icon.interaction.hovered,
  interactionSpecialDefault: icon.interaction.special["default"],
  interactionSpecialHovered: icon.interaction.special.hovered,
  brandDefault: icon.brand["default"],
  brandInverse: icon.brand.inverse,
  brandDecorative01: icon.brand.decorative['01'],
  brandDecorative02: icon.brand.decorative['02'],
  brandDecorative03: icon.brand.decorative['03'],
  brandDecorative04: icon.brand.decorative['04'],
  brandDecorative05: icon.brand.decorative['05'],
  brandDecorative06: icon.brand.decorative['06']
};

// TODO: Kept to avoid breaking changes
var COLOR_STYLES = exports.COLOR_STYLES = {
  inherit: KIND_STYLES.inherit,
  primary: KIND_STYLES.interactionDefault,
  secondary: KIND_STYLES.positive,
  action: KIND_STYLES["default"],
  error: KIND_STYLES.critical,
  disabled: KIND_STYLES.disabled
};
var SIZE_STYLES = exports.SIZE_STYLES = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '40px',
  xxlarge: '48px'
};